import React from 'react';
import classNames from 'classnames/bind';
import { UserInfoDropdownProps } from './navbar.types';
import styles from './userinfo.module.css';
import { Icon } from '@shopuptech/expo-shopup-ui';
import { useHistory } from 'react-router-dom';
import { REQUEST_ACCESS_PATH } from '../modules/mainhome/constants';
import { useUserLogin } from '../hooks/useUserLogin';

const cx = classNames.bind(styles);
const UserInfo = ({
  user,
  handleLogout,
  collapsable,
}: UserInfoDropdownProps) => {
  const { name, email, phone } = user;
  const { isRequestAccessFlow } = useUserLogin();
  const { push } = useHistory();
  const handleRequestAccess = () => {
    push(REQUEST_ACCESS_PATH);
  };
  return (
    <div className={cx('userinfo', { collapsable })}>
      <div className={cx('user')}>
        <Icon name="User" size="small" color="PRIMARY_BTN_COLOR" />
        {!collapsable && (
          <div>
            <p className={cx('font')} title={name}>
              {name}
            </p>
            {email && <p className={cx('font', 'fontsmall')}>{email}</p>}
            {phone && <p className={cx('font', 'fontsmall')}>{phone}</p>}
            <p className={cx('font', 'fontsmall')}>ID: {user.id}</p>
          </div>
        )}
      </div>

      {!collapsable && isRequestAccessFlow && (
        <div className={cx('request')} onClick={handleRequestAccess}>
          <Icon name="MailSend" size="small" color="PRIMARY_BTN_COLOR" />
          <p className={cx('font')}>Request Access</p>
        </div>
      )}

      <div onClick={handleLogout} className={cx('logout')}>
        <Icon name="Logout" size="small" color="TRANSPARENCY_BLACK_60" />
        {!collapsable && <p className={cx('font')}>Logout</p>}
      </div>
    </div>
  );
};

export default UserInfo;
